<h4 style="width:100%; text-align: center" class="add-section-text">{{t "r4b.modules.blockContent.addSection"}}</h4>
